import dayjs, { Dayjs } from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export const formatNumber = (
  value: number,
): string => {
  const formatted = Intl
    .NumberFormat(
      'pt-BR',
    ).format(value);

  return formatted;
};

export const formatStringDate = (
  stringDate: string,
): string => {
  const formatted = dayjs(stringDate)
    .toDate()
    .toLocaleDateString('pt-br');

  return formatted;
};

export const formatDate = (
  date: Dayjs,
): string => {
  const formatted = date
    .toDate()
    .toLocaleDateString('pt-br');

  return formatted;
};

export const parseUtcStringDate = (stringDate: string): Dayjs => {
  const parsedDate = dayjs(dayjs.utc(stringDate).format('YYYY-MM-DD'));
  return parsedDate;
};
